import { gql, useLazyQuery } from "@apollo/client";
import {
  ListMainCategoryQuery,
  ListMainCategoryQueryVariables,
} from "../generated/graphql";

const LIST_MAIN_CATEGORY_QUERY = gql`
  query listMainCategory {
    listMainCategory {
      ok
      err
      mainCategories {
        id
        name
        upload {
          url
        }
      }
    }
  }
`;

export const useListMainCategory = (
  onCompleted?: (data: ListMainCategoryQuery) => void
) => {
  return useLazyQuery<ListMainCategoryQuery, ListMainCategoryQueryVariables>(
    LIST_MAIN_CATEGORY_QUERY,
    {
      onCompleted,
      fetchPolicy: "network-only",
    }
  );
};
